import { AppError } from './app-error';

export class NotFoundError extends AppError {}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/not-found-error.ts